<header>
    <div class="width-container">
        <div>
            <a target="_parent" [href]="'HEADER.LOGO_URL' | translate" [attr.aria-label]="'HEADER.LOGO_ARIA_LABEL' | translate">
                <img alt="United MileagePlus logo" [src]=" assetsUrl + 'mp_logo.png'" />
                <img alt="Chase Bank logo" [src]=" assetsUrl + 'chase_logo.png'" />
            </a>
        </div>
    </div>
</header>